/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Vehicle_Sort_NumberInputs */

const fr_network_vehicle_sort_number = /** @type {(inputs: Network_Vehicle_Sort_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro`)
};

const en_network_vehicle_sort_number = /** @type {(inputs: Network_Vehicle_Sort_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number`)
};

/**
* | output |
* | --- |
* | "Number" |
*
* @param {Network_Vehicle_Sort_NumberInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicle_sort_number = /** @type {((inputs?: Network_Vehicle_Sort_NumberInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicle_Sort_NumberInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicle_sort_number(inputs)
	return en_network_vehicle_sort_number(inputs)
});